module.exports = __webpack_public_path__ + "img/eps-netpay.d9dcae48.png";